import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormValues} from 'src/pages/Permits/Food&BeverageLicenseManagment/NewApplicationForm/Type';

interface FoodBeverageFormState {
  formData: FormValues;
  AppId: {
    applicationId: number | null;
  };
}

const initialState: FoodBeverageFormState = {
  formData: {
    establishmentName: '',
    establishmentEmail: '',
    establishmentPhone: '',
    establishmentAddress: '',
    establishmentTown: '',
    blockLot: '',
    establishmentContactName: '',

    EstablishmentType: {},

    applicantName: '',
    applicantAddress: '',
    applicantSuitePOBox: '',
    applicantCity:'',
    applicantState: '',
    applicantZipCode: '',
    applicantEmail: '',
    applicantPhone: '',

    hasSecondaryContactInfo: false,
      secondaryContactName: '',
      secondaryDepartment: '',
      secondaryAddress: '',
      secondaryEmail: '',
      secondaryPhone: '',

    DocumentFileUpload: []
  },
  AppId: {
    applicationId: null
  }
};

const foodBeverageFormSlice = createSlice({
  name: 'foodBeverageForm',
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<Partial<FormValues>>) => {
      state.formData = {
        ...state.formData,
        ...action.payload
      };
    },
    updateAppId: (state, action: PayloadAction<{ applicationId: number }>) => {
      state.AppId = {
        ...state.AppId,
        ...action.payload
      };
    },
    resetFormData: (state) => {
      state.formData = { ...initialState.formData };
      state.AppId = { applicationId: null };
    }
  }
});

export const {
  updateFormData,
  updateAppId,
  resetFormData
} = foodBeverageFormSlice.actions;

export default foodBeverageFormSlice.reducer;
